import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import addBook from "../redux/books/thunk/addBook";
import updateBook from "../redux/books/thunk/updateBook";
import { bookUpdate } from "../redux/bookUpdate/bookUpdate";

const initialState = {
  name: "",
  author: "",
  thumbnail: "",
  price: 0,
  rating: 0,
  featured: false,
};

const BookForm = () => {
  const bookUpdateState = useSelector((state) => state.bookUpdate);
  const dispatch = useDispatch();

  const [bookValue, setBookValue] = useState(initialState);

  useEffect(() => {
    if (bookUpdateState) {
      setBookValue({
        ...bookUpdateState,
      });
    }
  }, [bookUpdateState]);

  const handleSubmit = (e, updateValue) => {
    e.preventDefault();

    if (updateValue) {
      dispatch(updateBook(bookUpdateState.id, bookValue));
      dispatch(bookUpdate(null));
      setBookValue(initialState);
    } else {
      dispatch(addBook(bookValue));
      setBookValue(initialState);
    }
  };

  return (
    <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
      <h4 className="mb-8 text-xl font-bold text-center">
        {bookUpdateState ? "Update Book" : "Add New Book"}
      </h4>
      <form
        className="book-form"
        onSubmit={(e) => handleSubmit(e, bookUpdateState && "updateBook")}
      >
        <div className="space-y-2">
          <label htmlFor="name">Book Name</label>
          <input
            required
            className="text-input"
            type="text"
            id="input-Bookname"
            name="name"
            value={bookValue.name}
            onChange={(e) =>
              setBookValue({ ...bookValue, name: e.target.value })
            }
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="category">Author</label>
          <input
            required
            className="text-input"
            type="text"
            id="input-Bookauthor"
            name="author"
            value={bookValue.author}
            onChange={(e) =>
              setBookValue({ ...bookValue, author: e.target.value })
            }
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="image">Image Url</label>
          <input
            required
            className="text-input"
            type="text"
            id="input-Bookthumbnail"
            name="thumbnail"
            value={bookValue.thumbnail}
            onChange={(e) =>
              setBookValue({
                ...bookValue,
                thumbnail: e.target.value,
              })
            }
          />
        </div>

        <div className="grid grid-cols-2 gap-8 pb-4">
          <div className="space-y-2">
            <label htmlFor="price">Price</label>
            <input
              required
              className="text-input"
              type="number"
              id="input-Bookprice"
              name="price"
              value={bookValue.price}
              onChange={(e) =>
                setBookValue({ ...bookValue, price: Number(e.target.value) })
              }
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="quantity">Rating</label>
            <input
              required
              className="text-input"
              type="number"
              id="input-Bookrating"
              name="rating"
              min="1"
              max="5"
              value={bookValue.rating}
              onChange={(e) =>
                setBookValue({
                  ...bookValue,
                  rating: Number(e.target.value),
                })
              }
            />
          </div>
        </div>

        <div className="flex items-center">
          <input
            id="input-Bookfeatured"
            type="checkbox"
            name="featured"
            checked={bookValue.featured}
            className="w-4 h-4"
            onChange={(e) =>
              setBookValue({
                ...bookValue,
                featured: e.target.checked,
              })
            }
          />
          <label htmlFor="featured" className="ml-2 text-sm">
            This is a featured book
          </label>
        </div>

        {bookUpdateState ? (
          <button type="submit" className="submit" id="submit">
            Update Book
          </button>
        ) : (
          <button type="submit" className="submit" id="submit">
            Add Book
          </button>
        )}
      </form>
    </div>
  );
};

export default BookForm;
